export default __webpack_public_path__ + "static/media/sad-dog.41322d07.jpg";